// extracted by mini-css-extract-plugin
export var socials = "footer-module--socials--21DNK";